import styled from 'styled-components';
import { color, font, label, space, ease } from '../../styles/tokens';

export const Switcher = styled.div`
  position: fixed;
  top: 14px;
  right: ${space.gutter};
  z-index: 70;
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 5px;
  border-radius: 999px;
  background: rgba(32, 26, 30, 0.55);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.16);

  button {
    ${label};
    font-family: ${font.body};
    font-size: 10px;
    letter-spacing: 0.14em;
    padding: 6px 12px;
    border: 0;
    border-radius: 999px;
    background: transparent;
    color: rgba(255, 255, 255, 0.55);
    cursor: pointer;
    transition: background 0.3s ${ease}, color 0.3s ${ease};

    &:hover {
      color: ${color.white};
    }

    &.active {
      background: ${color.fuchsia};
      color: ${color.white};
    }
  }
`;
